export default Object.freeze({
  Unset: 0,
  Normal: 1,
  Good: 2,
  Exceeded: 3,
});
